<template>
  <div v-if="response">
    <b-card>
      <h5 class="mb-3">📦 Import Result Summary</h5>
      <b-row>
        <b-col cols="12" md="4">
          <b-alert class="p-2" show variant="secondary"
            >Total Rows:
            <strong class="ml-2"> {{ response.total_rows }}</strong></b-alert
          >
        </b-col>
        <b-col cols="12" md="4">
          <b-alert class="p-2" show variant="success"
            >Success:
            <strong class="ml-2">{{ response.success_count }}</strong></b-alert
          >
        </b-col>
        <b-col cols="12" md="4">
          <b-alert class="p-2" show variant="danger"
            >Errors: <strong class="ml-2">{{ response.error_count }}</strong>
          </b-alert>
        </b-col>
      </b-row>
    </b-card>
    <!-- Success Data -->
    <b-card
      v-if="response.success_data && response.success_data.length"
      border-variant="success"
    >
      <h5 class="text-success mb-3">✅ Success Data</h5>
      <b-table
        striped
        hover
        small
        :items="response.success_data"
        :fields="successFields"
      >
        <template #cell(days_processed)="data">
          {{ data.item.days_processed }} days
        </template>
      </b-table>
    </b-card>

    <!-- Error Data -->
    <b-card
      v-if="response.errors && response.errors.length"
      border-variant="danger"
    >
      <h5 class="text-danger mb-3">❌ Error Data</h5>
      <b-table
        striped
        hover
        small
        :items="response.errors"
        :fields="errorFields"
        thead-class="text-nowrap"
      >
        <template #cell(errors)="data">
          <ul class="mb-0">
            <li v-for="(err, index) in data.item.errors" :key="index">{{
              err
            }}</li>
          </ul>
        </template>
        <template #cell(fleet_name)="data">
          <div class="text-nowrap">{{ data.item?.fleet_name }}</div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ImportResultRh',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // response: {
      // total_rows: 4,
      // success_count: 2,
      // error_count: 2,
      // success_data: [
      //   {
      //     row: 3,
      //     fleet_name: 'TB. TCP 201',
      //     power_type: 'MAIN ENGINE PORT',
      //     power_series: 'HITACHI - MGN 90L-11A',
      //     days_processed: 19,
      //   },
      //   {
      //     row: 5,
      //     fleet_name: 'TB. TCP 201',
      //     power_type: 'AUXILIARY ENGINE PORT',
      //     power_series: 'CUMMIN - 4BTA 3.9-GM 47',
      //     days_processed: 19,
      //   },
      // ],
      // errors: [
      //   {
      //     row: 4,
      //     fleet_name: 'TB. TCP 201',
      //     errors: [
      //       "Kombinasi Fleet 'TB. TCP 201', Power Type 'MAIN ENGINE STBD', dan Power Series 'YANMAR - 6RY17P-GV' tidak valid",
      //     ],
      //   },
      //   {
      //     row: 6,
      //     fleet_name: 'TB. TCP 201',
      //     errors: [
      //       'Year, Month, Fleet Name, Power Type, dan Power Series wajib diisi',
      //       'Year harus berupa angka antara 2020-2030',
      //       'Month harus berupa nama bulan valid (January–December)',
      //     ],
      //   },
      // ],
      // },
      successFields: [
        { key: 'row', label: 'Row' },
        { key: 'fleet_name', label: 'Fleet Name' },
        { key: 'power_type', label: 'Power Type' },
        { key: 'power_series', label: 'Power Series' },
        { key: 'days_processed', label: 'Days Processed' },
      ],
      errorFields: [
        { key: 'row', label: 'Row' },
        { key: 'fleet_name', label: 'Fleet Name' },
        { key: 'errors', label: 'Error Messages' },
      ],
    }
  },
}
</script>

<style scoped>
ul {
  padding-left: 1.2rem;
}
</style>
